import React from 'react';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from './context/ThemeContext';
import AnimatedRoutes from './components/auth/AnimatedRoutes';
import { LanguageProvider } from './context/LanguageContext';
import { MerchantProvider } from './context/MerchantContext';
import { NetworkProvider } from './context/NetworkContext';
import { BranchProvider } from './context/BranchContext';
import OfflineBanner from './components/ui/OfflineBanner';
import { Analytics } from "@vercel/analytics/react"

const App = () => {
  return (
    <div>
      <NetworkProvider>
        <OfflineBanner />
        <MerchantProvider>
          <ThemeProvider>
            <LanguageProvider>
              <AuthProvider>
              <BranchProvider>
                <Toaster
                  position="top-right"
                  reverseOrder={false}
                  gutter={8}
                  toastOptions={{
                    // Default options
                    duration: 4000,
                    style: {
                      background: '#363636',
                      color: '#fff',
                    },
                    // Success
                    success: {
                      duration: 4000,
                      iconTheme: {
                        primary: '#10B981',
                        secondary: '#fff',
                      },
                    },
                    // Error
                    error: {
                      duration: 5000,
                      iconTheme: {
                        primary: '#EF4444',
                        secondary: '#fff',
                      },
                    },
                  }}
                />
                <AnimatedRoutes />
              </BranchProvider>
              </AuthProvider>
            </LanguageProvider>
          </ThemeProvider>
        </MerchantProvider>
      </NetworkProvider>
      <Analytics />
    </div>
  );
}

export default App;
